"use strict";

angular.module("customer")
.factory("StocksService", function(
    $resource, FlashBag, $rootScope, $stateParams, $q, $http, ReadOnlyPermissionService, common, appConfig
) {
    var TABS = {
        SALES: 0,
        RETURNS: 1,
        INVENTORY_RETURNS: 2,
        CUSTOM_DISCOUNTS: 3
    }

    var stockUpdateService = $resource(appConfig.API_SERVER + "/catalog/customer/products/inventory/edit/:id/", {id: "@id"}, {
        update: {method: "PATCH"}
    });

    function validateDeliveryDate(vendor) {
        vendor.isDeliveryDateValid = vendor.delivery_date !== 'not-selected';
        if (!vendor.isDeliveryDateValid) {
            common.scrollTo('#select-delivery-dates', -100);
        }
        return vendor.isDeliveryDateValid
    }

    function create_inventory_product(product_id, catalogEntryId, quantity) {
        var stock = new stockUpdateService();
        stock.product = product_id;
        stock.catalog_entry = catalogEntryId;
        if (quantity !== null) {
            stock.inventory_quantity = quantity;
        }
        return stock.$save();
    }

    function getLengthClass(value) {
        var valueLength = String(value).length;
        if (valueLength < 2) {
            return "one";
        }
        else if (valueLength < 3) {
            return "ten";
        }
        else if (valueLength < 4) {
            return "hundred";
        }
        else if (valueLength < 5) {
            return "thousand";
        }
        else {
            return "ten-thousand";
        }
    }

    function fetch(url, ordering, page) {
        var service = $resource(appConfig.API_SERVER + url, {}, {
            query: {
                method: "GET",
                isArray: false
            }
        });

        var field = common.getSortField(ordering);
        var direction = common.getSortDirection(ordering);

        var params = {
            field: field,
            direction: direction,
            page: page,
            search: $stateParams.search,
            vendor: $stateParams.vendorId,
            catalog: $stateParams.catalog,
            product_category: $stateParams.categories
        };

        var catalogEntry = $stateParams.product;
        if (catalogEntry) {
            params["catalog_entry"] = catalogEntry;
            params["ignore_preferred_mode"] = 1;
        }

        return service.query(params,
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    }

    return {
        TABS: TABS,
        fetchSales: function(ordering, page) {
            var url = "/catalog/customer/products/";
            return fetch(url, ordering, page);
        },
        fetchReturns: function(ordering, page) {
            var url = "/catalog/customer/products/returns/";
            return fetch(url, ordering, page);
        },
        fetchInventoryReturns: function(ordering, page) {
            var url = "/catalog/customer/products/inventory-returns/";
            return fetch(url, ordering, page);
        },
        fetchDiscounts: function(ordering, page) {
            var url = "/catalog/customer/products/discounts/";
            return fetch(url, ordering, page);
        },
        getVendors: function() {
            var service = $resource(appConfig.API_SERVER + "/catalog/customer/products/vendors/", {}, {
                query: {
                    method: "GET",
                    isArray: true
                }
            });

            var params = {
                vendor: $stateParams.vendorId,
                catalog: $stateParams.catalog,
                product_category: $stateParams.categories
            };

            if ($stateParams.product) {
                params["ignore_preferred_mode"] = 1;
            }

            return service.query(
                params,
                function() {
                },
                function errorCallback(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        updateInventoryQuantity: function(catalogEntry, quantity, vendor) {
            var deferred = $q.defer();
            var product = catalogEntry.product;
            if (validateDeliveryDate(vendor) && catalogEntry) {
                var inventory_product = product.inventory_product;
                inventory_product.inventory_quantity = quantity;

                if (inventory_product.id) {
                    var params = {
                        id: inventory_product.id,
                        catalog_entry: catalogEntry.id,
                        inventory_quantity: quantity
                    };
                    return stockUpdateService.update(params).$promise;
                }
                else {
                    return create_inventory_product(product.id, catalogEntry.id, quantity);
                }
            }
            else {
                deferred.reject(true);
                return deferred.promise;
            }
        },
        updateDeliveryData: function(vendor) {
            var delivery_data = _.find(vendor.list_delivery_dates, function(o) {
                return o.delivery_date === vendor.delivery_date;
            });
            if (delivery_data) {
                vendor.threshold_datetime = delivery_data.threshold_datetime;
                vendor.delivery_rule_id = delivery_data.rule_id;
            }
        },

        isOutOfStock: function(catalogEntry) {
            return (
                catalogEntry.inventory_quantity === 0
                || (catalogEntry.minimal_available_quantities && catalogEntry.minimal_available_quantities.length === 1)
            );
        },

        isProductVariantOutOfStock: function(catalogEntryVariant) {
            return catalogEntryVariant && catalogEntryVariant.inventory_quantity === 0;
        },

        resetInventory: function(vendorId) {
            return $http.post(appConfig.API_SERVER + "/catalog/customer/products/inventory/reset/", {
                vendor_id: vendorId
            });
        },

        create_inventory_product: create_inventory_product,
        getLengthClass: getLengthClass,
        validateDeliveryDate: validateDeliveryDate
    };

})

.factory("StockProductDetailsModalService", function(
    $resource, FlashBag, $q, $httpParamSerializer, StocksService, ModalService, appConfig
) {
    var productDetailsResource = $resource(appConfig.API_SERVER + "/catalog/customer/products/stock-details/:id/", {
        id: "@id"
    }, {
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var inventoryEditResource = $resource(appConfig.API_SERVER + "/catalog/customer/products/inventory/:id/", {
        id: "@id"
    }, {
        get: {method: "GET", isArray: false},
        update: {method: "PUT"}
    });

    function get_inventory_product(inventory_product_id, catalogEntryId) {
        return inventoryEditResource.get({id: inventory_product_id, catalog_entry: catalogEntryId});
    }

    function update_delivery_inventory_target(inventory_product_id, catalogEntryId, delivery_inventory_target) {
        return get_inventory_product(inventory_product_id, catalogEntryId).$promise.then(function(data) {
            data.delivery_inventory_target = delivery_inventory_target;
            return data.$update();
        });
    }

    function update_default_inventory_target(inventory_product_id, catalogEntryId, default_target_inventory_level) {
        return get_inventory_product(inventory_product_id, catalogEntryId).$promise.then(function(data) {
            data.delivery_inventory_target = [];
            data.default_target_inventory_level = default_target_inventory_level;
            return data.$update();
        });
    }

    function set_inventory_target(catalogEntry, inventory_product, target_inventory_level, update_function) {
        var inventory_product_id = inventory_product.id;

        if (inventory_product_id) {
            return update_function(inventory_product_id, catalogEntry.id, target_inventory_level);
        }
        else {
            return StocksService.create_inventory_product(catalogEntry.product.id, catalogEntry.id, null).then(function(inventory_product) {
                return update_function(inventory_product.id, catalogEntry.id, target_inventory_level);
            });
        }
    }

    function getCatalogEntryDetails(id) {
        return productDetailsResource.get({id: id});
    }

    return {
        showProductDetails: function(catalogEntry, params) {
            return getCatalogEntryDetails(catalogEntry.id).$promise.then(function(data) {
                angular.extend(catalogEntry, data);
                var attrs = {catalogEntry: catalogEntry};
                angular.extend(attrs, params);

                // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
                return ModalService.showModal({
                    templateUrl: require("./catalog-entry/stock-product-details.modal.html"),
                    controller: "StockProductDetailsModal",
                    controllerAs: "stockProductDetailsModalCtrl",
                    inputs: {$attrs: attrs}
                }).then(function(modal) {
                    modal.element.modal({
                        backdrop: "static",
                        keyboard: false
                    });
                    return modal.close.then(function(result) {
                        return result;
                    });
                });
            });
        },
        getCatalogEntryDetails: getCatalogEntryDetails,
        setDeliveryInventoryTarget: function(catalogEntry, inventory_product) {
            var delivery_inventory_target = inventory_product.delivery_inventory_target;
            return set_inventory_target(catalogEntry, inventory_product, delivery_inventory_target, update_delivery_inventory_target);
        },
        setDefaultInventoryTarget: function(catalogEntry, inventory_product) {
            var default_target_inventory_level = inventory_product.default_target_inventory_level;
            return set_inventory_target(catalogEntry, inventory_product, default_target_inventory_level, update_default_inventory_target);
        },

        queryProductHistory: function(productID, afterDate) {
            var params = $httpParamSerializer({ProductID: productID, OrderedAfter: afterDate});
            var service = $resource(appConfig.API_SERVER + "/catalog/customer/products/order-history/?" + params, {}, {
                query: {
                    method: "get",
                    isArray: true
                }
            });
            return service.query();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/stock.service.js
// module id = 920
// module chunks = 0